<div #titleElement mat-dialog-title>
  <button type="button" mat-icon-button (click)="back()">
    <ft-icon name="arrow-left" class="ft-icon--2" />
  </button>
  <div class="ft-title__stepper">
    <div i18n>Properties</div>
    <div i18n>Payment plan</div>
    <div
      [ngStyle]="{
        'margin-bottom': '-' + (stepper ? stepper.selectedIndex : 0) * 29 + 'px'
      }">
      @if (data.simulation?.operationNumber) {
        <ng-container i18n>Edit offer</ng-container>
      } @else if (type() === 'credit') {
        <ng-container i18n>Register credit</ng-container>
      } @else if (type() === 'simulation') {
        <ng-container i18n>Simulate credit</ng-container>
      }
    </div>
  </div>
</div>
<div #contentElement mat-dialog-content class="p-0">
  <div
    class="ft-observe-interseting"
    (ftObserveIntersecting)="
      appService.setOverlapped($event, titleElement)
    "></div>
  @if (!loading()) {
    <mat-stepper
      #stepper
      class="ft-stepper"
      (selectionChange)="scrollToTop($event)">
      <mat-step [stepControl]="simulationForm">
        <form
          id="simulationForm"
          [formGroup]="simulationForm"
          (ngSubmit)="submit()"
          class="mt-3">
          <div class="ft-grid ft-grid--c-6">
            <div class="ft-cs-6">
              <mat-form-field floatLabel="always" class="form-field--lg w-100">
                <mat-label i18n>Amount</mat-label>
                <input
                  type="number"
                  matInput
                  formControlName="amount"
                  class="text-end"
                  min="0" />
                <button
                  type="button"
                  mat-button
                  matSuffix
                  [matMenuTriggerFor]="currenciesMenu"
                  [disabled]="submitting() || mode() === 'update'"
                  style="padding-top: 1rem">
                  <div class="ft-item">
                    <div>{{ simulationForm.get('country')?.value?.value }}</div>
                    <ft-icon name="angle-down" />
                  </div>
                </button>
                @if (simulationForm.get('amount')?.invalid) {
                  <mat-error>
                    {{
                      appService.getErrorMessage(simulationForm.get('amount'), {
                        required: requiredAmountMessage,
                        pattern: messageCommaNotAllowed()
                      })
                    }}
                  </mat-error>
                }
                <mat-hint i18n>Example {{ amountSample }}</mat-hint>
              </mat-form-field>
              <mat-menu #currenciesMenu="matMenu">
                @for (country of countries(); track country.id) {
                  <button
                    type="button"
                    mat-menu-item
                    [disabled]="
                      simulationForm.get('country')?.value?.id === country.id
                    "
                    (click)="setCountry(country)"
                    style="padding-top: 1rem">
                    {{ country.value }} - {{ country.description }}
                  </button>
                }
              </mat-menu>
            </div>
            <div class="ft-cs-4">
              <mat-form-field floatLabel="always" class="w-100">
                <mat-label i18n>Term</mat-label>
                <input
                  type="number"
                  matInput
                  formControlName="term"
                  class="text-end" />
                <button
                  type="button"
                  mat-button
                  matSuffix
                  [matMenuTriggerFor]="frequencyMenu"
                  [disabled]="submitting()"
                  style="padding-top: 1rem">
                  <div class="ft-item">
                    <div>
                      {{ simulationForm.get('frequency')?.value?.description }}
                    </div>
                    <ft-icon name="angle-down" />
                  </div>
                </button>
                @if (simulationForm.get('term')?.invalid) {
                  <mat-error>
                    {{
                      appService.getErrorMessage(simulationForm.get('term'), {
                        required: requiredTermMessage
                      })
                    }}
                  </mat-error>
                }
                <mat-hint i18n>
                  Example
                  {{
                    '12 ' + simulationForm.get('frequency')?.value?.description
                  }}
                </mat-hint>
              </mat-form-field>
              <mat-menu #frequencyMenu="matMenu">
                @for (frequency of frequencies(); track frequency.id) {
                  <button
                    type="button"
                    mat-menu-item
                    [disabled]="
                      simulationForm.get('frequency')?.value === frequency.id
                    "
                    (click)="setFrequency(frequency)">
                    {{ frequency.description }}
                  </button>
                }
              </mat-menu>
            </div>
            <div class="ft-cs-2">
              <mat-form-field floatLabel="always" class="w-100">
                <mat-label i18n>Rate</mat-label>
                <input
                  type="number"
                  matInput
                  formControlName="rate"
                  class="text-end"
                  min="0" />
                <div matSuffix style="padding-top: 1rem">%</div>
                @if (simulationForm.get('rate')?.invalid) {
                  <mat-error>
                    {{
                      appService.getErrorMessage(simulationForm.get('rate'), {
                        pattern: messageCommaNotAllowed()
                      })
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="ft-cs-6">
              <mat-form-field
                floatLabel="always"
                floatLabel="always"
                class="w-100">
                <mat-label i18n>Amortization table type</mat-label>
                <mat-select formControlName="tableType">
                  <mat-select-trigger>
                    {{
                      simulationForm.get('tableType')?.value
                        ? simulationForm.get('tableType')?.value?.description
                        : ''
                    }}
                  </mat-select-trigger>
                  @for (tableType of tableTypes(); track tableType.id) {
                    <mat-option [value]="tableType">
                      {{ tableType.description }}
                    </mat-option>
                  }
                </mat-select>
                @if (simulationForm.get('tableType')?.invalid) {
                  <mat-error>
                    {{
                      appService.getErrorMessage(
                        simulationForm.get('tableType')
                      )
                    }}
                  </mat-error>
                }
                <mat-hint i18n>
                  Method for calculating installments and interest
                </mat-hint>
              </mat-form-field>
            </div>
            <div class="ft-cs-3">
              <mat-form-field floatLabel="always" class="w-100">
                <mat-label i18n>Start date</mat-label>
                <input
                  matInput
                  [matDatepicker]="effectiveDatePicker"
                  [min]="effectiveDateMin()"
                  [max]="effectiveDateMax()"
                  readonly
                  (click)="effectiveDatePicker.open()"
                  formControlName="effectiveDate" />
                <mat-hint>{{ appService.dateFormatHint() }}</mat-hint>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="effectiveDatePicker"></mat-datepicker-toggle>
                <mat-datepicker touchUi #effectiveDatePicker></mat-datepicker>
                @if (simulationForm.get('effectiveDate')?.invalid) {
                  <mat-error>
                    {{
                      appService.getErrorMessage(
                        simulationForm.get('effectiveDate')
                      )
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="ft-cs-3">
              <mat-form-field floatLabel="always" class="w-100">
                <mat-label floatLabel="always" i18n>
                  Pay starting from
                </mat-label>
                <input
                  matInput
                  [matDatepicker]="firstPaymentDatePicker"
                  formControlName="firstPaymentDate"
                  readonly
                  (click)="firstPaymentDatePicker.open()"
                  [min]="getMinDate()"
                  [max]="firstPaymentDateMax()" />
                <mat-hint>{{ appService.dateFormatHint() }}</mat-hint>
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="firstPaymentDatePicker"></mat-datepicker-toggle>
                <mat-datepicker
                  touchUi
                  #firstPaymentDatePicker></mat-datepicker>
                @if (simulationForm.get('firstPaymentDate')?.invalid) {
                  <mat-error>
                    {{
                      appService.getErrorMessage(
                        simulationForm.get('firstPaymentDate')
                      )
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          @if (marketRates() && type() === 'simulation') {
            <h3 class="d-flex align-items-center gap-2">
              <div i18n>Market rates</div>
              <ft-icon
                name="information"
                #ratesTooltip="matTooltip"
                (click)="ratesTooltip.toggle()"
                i18n-matTooltip
                matTooltip="Market rates are average interest rates offered by financial institutions. They serve as a benchmark to ensure that loan conditions are competitive and in line with the current economic context." />
            </h3>
            <div class="ft-table__wrapper">
              <table class="ft-table">
                <thead>
                  <tr>
                    <th></th>
                    <th class="text-center" i18n>Investments</th>
                    <th class="text-center" i18n>Loans</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th class="text-start" i18n>Banks</th>
                    <td class="text-center">
                      {{ marketRates()?.investments?.bank?.rate }}%
                    </td>
                    <td class="text-center">
                      {{ marketRates()?.credit?.bank?.rate }}%
                    </td>
                  </tr>
                  <tr>
                    <th class="text-start" i18n>Cooperatives</th>
                    <td class="text-center">
                      {{ marketRates()?.investments?.cooperatives?.rate }}%
                    </td>
                    <td class="text-center">
                      {{ marketRates()?.credit?.cooperatives?.rate }}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </form>
      </mat-step>
      <mat-step>
        <div
          class="ft-card ft-card--primary flex-grow-1 mt-3"
          style="position: sticky; left: 0">
          <div class="ft-card__body ft-card__body--primary">
            <div class="d-flex flex-column flex-md-row gap-3">
              @if (profileId !== profileIds.BasicBeneficiary) {
                <div class="ft-data-field ft-responsive">
                  <div class="ft-data-field__label" i18n>
                    Interest to be earned
                  </div>
                  <div
                    class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
                    style="font-size: var(--ft-display-font-size-lg)">
                    <div>{{ conditions()?.interestToEarn | number }}</div>
                    <div class="ft-suffix ft-suffix--sm">
                      {{ simulationForm.get('country')?.value?.value }}
                    </div>
                    <ft-icon
                      name="information"
                      class="text-white ft-icon--1 ms-1"
                      #totalTooltip="matTooltip"
                      (click)="totalTooltip.toggle()"
                      i18n-matTooltip
                      [matTooltip]="
                        totalToReceive +
                        ' ' +
                        ((simulationForm.get('amount')?.value || 0) +
                          (conditions()?.interestToEarn || 0) | number)
                      " />
                  </div>
                </div>
              } @else {
                <div class="ft-data-field ft-responsive">
                  <div class="ft-data-field__label" i18n>Installment</div>
                  <div
                    class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
                    style="font-size: var(--ft-display-font-size-lg)">
                    <div>{{ conditions()?.quotaAmount | number }}</div>
                    <div class="ft-suffix ft-suffix--sm">
                      {{ simulationForm.get('country')?.value?.value }}
                    </div>
                  </div>
                </div>
              }
              @if (profileId !== profileIds.BasicBeneficiary) {
                <div class="ft-separator"></div>
                <div class="ft-data-field ft-responsive">
                  <div class="ft-data-field__label" i18n>Installment</div>
                  <div
                    class="ft-data-field__value d-flex align-items-center justify-content-center gap-1">
                    <div>{{ conditions()?.quotaAmount | number }}</div>
                    <div class="ft-suffix">
                      {{ simulationForm.get('country')?.value?.value }}
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <div class="ft-card__body ft-card__body--secondary">
            <div class="d-flex gap-3">
              <div class="ft-data-field flex-grow-1">
                <div class="ft-data-field__label" i18n>Amount</div>
                <div class="ft-data-field__value">
                  {{ simulationForm.get('amount')?.value | number }}
                </div>
              </div>
              <div class="ft-separator"></div>
              <div class="ft-data-field flex-grow-1">
                <div class="ft-data-field__label" i18n>Term</div>
                <div class="ft-data-field__value">
                  {{ simulationForm.get('term')?.value }}
                  {{ simulationForm.get('frequency')?.value?.description }}
                </div>
              </div>
              <div class="ft-separator"></div>
              <div class="ft-data-field flex-grow-1">
                <div class="ft-data-field__label" i18n>Rate</div>
                <div class="ft-data-field__value">
                  {{ simulationForm.get('rate')?.value }}%
                </div>
              </div>
            </div>
          </div>
        </div>
        @if (marketSimulation() && type() === 'simulation') {
          <h3
            class="d-flex align-items-center gap-2"
            style="position: sticky; left: 0">
            <div i18n>Market offers</div>
            <ft-icon
              name="information"
              #ratesTooltip="matTooltip"
              (click)="ratesTooltip.toggle()"
              i18n-matTooltip
              matTooltip="Market rates are those that reflect the average interest rates offered by financial institutions under current economic conditions. These rates serve as a reference to ensure that loan conditions are competitive and in line with the market situation." />
          </h3>
          <div class="ft-table__wrapper" style="position: sticky; left: 0">
            <table class="ft-table">
              <thead>
                <tr>
                  <th></th>
                  <th class="text-center lh-1">
                    <div i18n>Investments</div>
                  </th>
                  <th class="text-center lh-1">
                    <div i18n>Loans</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th class="text-start" i18n>Banks</th>
                  <td class="text-center lh-1">
                    <div>
                      {{
                        marketSimulation()?.investments?.bank?.profit | number
                      }}
                    </div>
                    <small class="text-muted">
                      {{ marketSimulation()?.investments?.bank?.rate }}%
                    </small>
                  </td>
                  <td class="text-center lh-1">
                    <div>
                      {{
                        marketSimulation()?.consumerCredit?.bank?.profit
                          | number
                      }}
                    </div>
                    <small class="text-muted">
                      {{ marketSimulation()?.consumerCredit?.bank?.rate }}%
                    </small>
                  </td>
                </tr>
                <tr>
                  <th class="text-start" i18n>Cooperatives</th>
                  <td class="text-center lh-1">
                    <div>
                      {{
                        marketSimulation()?.investments?.cooperatives?.profit
                          | number
                      }}
                    </div>
                    <small class="text-muted">
                      {{ marketSimulation()?.investments?.cooperatives?.rate }}%
                    </small>
                  </td>
                  <td class="text-center lh-1">
                    <div>
                      {{
                        marketSimulation()?.consumerCredit?.cooperatives?.profit
                          | number
                      }}
                    </div>
                    <small class="text-muted">
                      {{
                        marketSimulation()?.consumerCredit?.cooperatives?.rate
                      }}%
                    </small>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        }
        <h3
          class="d-flex align-items-center gap-2"
          style="position: sticky; left: 0"
          i18n>
          Amortization table
        </h3>
        <div class="ft-card" style="width: fit-content; min-width: 100%">
          <table class="ft-table">
            <thead>
              <tr>
                <th></th>
                <th i18n>Date</th>
                <th class="text-end text-nowrap" i18n>Capital balance</th>
                <th class="text-end" i18n>Capital</th>
                <th class="text-end" i18n>Interest</th>
                <th class="text-end" i18n>Installment</th>
              </tr>
            </thead>
            <tbody>
              @for (record of conditions()?.paymentTable; track record.number) {
                <tr>
                  <th class="text-start">{{ record.number }}</th>
                  <td class="text-nowrap">
                    {{ record.dueDate | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="text-end">{{ record.prinAmtBal | number }}</td>
                  <td class="text-end">{{ record.prinAmt | number }}</td>
                  <td class="text-end">{{ record.interest | number }}</td>
                  <td class="text-end">{{ record.quotaAmount | number }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (!pageCompleted()) {
          <div
            class="ft-table__loader"
            (ftObserveIntersecting)="nextPage($event)">
            <ft-progress class="ft-progress--2"></ft-progress>
          </div>
        }
      </mat-step>
      @if (profileId !== profileIds.BasicBeneficiary) {
        <mat-step>
          <form
            id="propertiesForm"
            [formGroup]="propertiesForm"
            (ngSubmit)="submit()"
            class="d-flex flex-column gap-3 mt-3">
            <mat-form-field class="w-100">
              <mat-label i18n>Beneficiary</mat-label>
              <mat-select
                formControlName="beneficiary"
                [compareWith]="compareItem">
                <mat-select-trigger>
                  {{
                    propertiesForm.get('beneficiary')?.value?.description || ''
                  }}
                </mat-select-trigger>
                @for (
                  beneficiary of beneficiaries.accumulated() ?? [];
                  track beneficiary.sequence
                ) {
                  <mat-option [value]="beneficiary">
                    {{ beneficiary.description }}
                  </mat-option>
                }
                <mat-option
                  isGranted="btn-add-beneficiary"
                  (click)="openBeneficiary()">
                  <div class="ft-item">
                    <ft-icon name="plus" />
                    <div i18n>New beneficiary</div>
                  </div>
                </mat-option>
              </mat-select>
              @if (propertiesForm.get('beneficiary')?.invalid) {
                <mat-error>
                  {{
                    appService.getErrorMessage(
                      propertiesForm.get('beneficiary')
                    )
                  }}
                </mat-error>
              }
            </mat-form-field>
            <mat-form-field class="w-100" isGranted="dwl-group">
              <mat-label i18n>Group</mat-label>
              <mat-select formControlName="group" [compareWith]="compareItem">
                <mat-select-trigger>
                  {{ propertiesForm.get('group')?.value?.description }}
                </mat-select-trigger>
                <mat-option [value]="null" i18n>No group</mat-option>
                @for (
                  group of groups.accumulated() ?? [];
                  track group.sequence
                ) {
                  <mat-option [value]="group">
                    {{ group.description }}
                  </mat-option>
                }
                <mat-option isGranted="btn-add-group" (click)="openGroup()">
                  <div class="ft-item">
                    <ft-icon name="plus" />
                    <div i18n>New group</div>
                  </div>
                </mat-option>
              </mat-select>
              @if (propertiesForm.get('group')?.invalid) {
                <mat-error>
                  {{ appService.getErrorMessage(propertiesForm.get('group')) }}
                </mat-error>
              }
            </mat-form-field>
            @if (type() === 'credit') {
              <h3 class="m-0" i18n>Notifications</h3>
              <p class="m-0" i18n>
                We indicate whether you wish to activate any of the following
                notifications so that they are received by the client.
              </p>
              <div class="d-flex flex-column gap-3">
                <mat-checkbox formControlName="notifyPayment">
                  <div i18n>Payment reminder</div>
                  <small class="text-muted" i18n>
                    If you activate this option, we will send reminders to your
                    beneficiary before each installment is due.
                  </small>
                </mat-checkbox>
                <mat-checkbox formControlName="notifyOverduePayment">
                  <div i18n>Reminder of overdue payments</div>
                  <small class="text-muted" i18n>
                    If you activate this option, we will send reminders to your
                    beneficiary about the pending installments.
                  </small>
                </mat-checkbox>
                <mat-checkbox formControlName="notifySendingReceipts">
                  <div i18n>Sending receipts</div>
                  <small class="text-muted" i18n>
                    If you activate this option, we will send a notification to
                    your beneficiary each time you record a payment on the loan.
                  </small>
                </mat-checkbox>
              </div>
            }
          </form>
        </mat-step>
      }
    </mat-stepper>
  } @else {
    <div
      class="text-center h-100 d-flex align-items-center justify-content-center">
      <ft-progress class="ft-progress--3"></ft-progress>
    </div>
  }
  <div
    class="ft-observe-interseting"
    (ftObserveIntersecting)="
      appService.setOverlapped($event, actionsElement)
    "></div>
</div>
<div #actionsElement mat-dialog-actions>
  <div class="ft-actions__stepper">
    <div
      [ngStyle]="{
        'margin-top': '-' + (stepper ? stepper.selectedIndex : 0) * 40 + 'px'
      }">
      <button
        type="submit"
        form="simulationForm"
        mat-flat-button
        color="primary"
        [disabled]="!simulationForm.valid || submitting()">
        @if (!submitting()) {
          <div class="ft-item">
            <div i18n>Next</div>
            <ft-icon name="angle-right" />
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
        }
      </button>
    </div>
    <div class="ft-actions__group">
      @if (mode() !== 'update') {
        @if (allowSharing()) {
          <button
            type="button"
            mat-stroked-button
            (click)="share(simulationForm.value)"
            [disabled]="sharing()">
            @if (!sharing()) {
              <div class="ft-item">
                <ft-icon name="share" />
                <div i18n>Share</div>
              </div>
            } @else {
              <ng-container
                *ngTemplateOutlet="submittingTemplate"></ng-container>
            }
          </button>
        } @else {
          <button
            type="button"
            mat-stroked-button
            (click)="share(simulationForm.value, true)">
            @if (!sharing()) {
              <div class="ft-item gap-2">
                <ft-icon name="download" class="ft-icon--2" />
                <div i18n>Download</div>
              </div>
            } @else {
              <ng-container
                *ngTemplateOutlet="submittingTemplate"></ng-container>
            }
          </button>
        }
      }
      @if (profileId !== profileIds.BasicBeneficiary) {
        <button
          type="button"
          mat-flat-button
          color="primary"
          (click)="submit()">
          <div class="ft-item">
            <div i18n>Next</div>
            <ft-icon name="angle-right" />
          </div>
        </button>
      } @else {
        <button
          type="button"
          mat-flat-button
          color="primary"
          mat-dialog-close
          i18n>
          Close
        </button>
      }
    </div>
    <div>
      <button
        type="submit"
        form="propertiesForm"
        mat-flat-button
        color="primary"
        [disabled]="propertiesForm.invalid || submitting()">
        @if (!submitting()) {
          <div class="ft-item">
            <div i18n>Save</div>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
        }
      </button>
    </div>
  </div>
</div>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
